<div id="reports-list-modal" class="common-popup-view data-cancel">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Anular datos cancelados</h2>
    </div>

    <form [formGroup]="form">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="full">
                        <h2>Empresa</h2>
                        <app-tree-view (companyNode)="onCompanySelcted($event)" [origin]="1"></app-tree-view>
                    </div>
                </div>
                <div class="block-looper">
                    <div class="full">
                        <h2>Apellidos</h2>
                        <mat-form-field appearance="fill">
                            <input matInput formControlName="apellidos">
                        </mat-form-field>
                        <mat-error
                            *ngIf="form.controls.apellidos.touched && form.controls.apellidos.hasError('required')">
                            Obligatorio
                        </mat-error>
                    </div>
                </div>
                <div class="block-looper">
                    <div class="full">
                        <h2>Nombre</h2>
                        <mat-form-field appearance="fill">
                            <input matInput formControlName="nombre">
                        </mat-form-field>
                        <mat-error *ngIf="form.controls.nombre.touched && form.controls.nombre.hasError('required')">
                            Obligatorio
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onAccept()"><span
                    class="mat-button-wrapper unset-position">Aceptar</span></button>
            <button mat-button color="accent" class="cancel" (click)="onCancel()"><span
                    class="mat-button-wrapper unset-position">Cancelar</span></button>
        </div>
    </form>
</div>